import { Injectable } from '@angular/core';
import { CinetykApiService } from './cinetyk-api.service';
import { Prodotto, ProdottoFrontEnd, Variante } from '../models/prodotto';
import Utility from '../helpers/utility';
import { MediaObject } from '../models/media-object';
import { GlobalComponent } from '../../global-component';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  public varianti?: Variante[];
  constructor(private cinetykApiService: CinetykApiService) { }

/*
getPosts() {
    const promise = new Promise<void>((resolve, reject) => {
      const apiURL = this.api;
      this.http.get<Post[]>(apiURL).subscribe({
        next: (res: any) => {
          this.data = res.map((res: any) => {
            return new Post(res.userId, res.id, res.title, res.body);
          });
          resolve();
        },
        error: (err: any) => {
          reject(err);
        },
        complete: () => {
          console.log('complete');
        },
      });
    });
    return promise;
  }
*/

  getProdottoConImmaginiById(id:number){
    let promise = new Promise<ProdottoFrontEnd>((resolve,reject)=>{
      let p:ProdottoFrontEnd;
      this.cinetykApiService.getProdottoById(id).subscribe({ next:(d:Prodotto)=>{
        p ={
          altezza : d.altezza,
          categoria : d.categoria,
          description : d.description,
          id : d.id,
          larghezza : d.larghezza,
          magazzino : d.magazzino,
          nome : d.nome,
          peso : d.peso,
          prezzo : d.prezzo,
          sku: d.sku,
          produttore: d.produttore,
          pubblicato: d.pubblicato,
          immagini: [],
          tempoProduzione: d.tempoProduzione,
          evidenza: d.evidenza,
          limitata: d.limitata
        };
        if(d.immagini && d.immagini.length>0){
          d.immagini.forEach(element => {
            this.cinetykApiService.getImageById(+Utility.ClearId(String(element))).subscribe((i:MediaObject)=>{
              i.filePath = GlobalComponent.BASE_PATH_IMAGE + i.filePath;
              p.immagini.push(i);

              })
          });
        }else{
          
        }
        //return p;
        resolve(p);
      }})
    }) 
    return promise;
  }

  getProdottoConImmaginePrincipaleById(id:number){
    let promise = new Promise<ProdottoFrontEnd>((resolve,reject)=>{
      let p:ProdottoFrontEnd;
      this.cinetykApiService.getProdottoById(id).subscribe({ next:(d:Prodotto)=>{
        p ={
          altezza : d.altezza,
          categoria : d.categoria,
          description : d.description,
          id : d.id,
          larghezza : d.larghezza,
          magazzino : d.magazzino,
          nome : d.nome,
          peso : d.peso,
          prezzo : d.prezzo,
          sku: d.sku,
          produttore: d.produttore,
          pubblicato: d.pubblicato,
          immagini: [],
          tempoProduzione: d.tempoProduzione,
          evidenza: d.evidenza,
          limitata: d.limitata
        };
        if(d.immagini && d.immagini.length>0){
          this.cinetykApiService.getImageById(+Utility.ClearId(String(d.immagini[0]))).subscribe((i:MediaObject)=>{
            i.filePath = GlobalComponent.BASE_PATH_IMAGE + i.filePath;
                
            })
        }else{

        }
        //return p;
        resolve(p);
      }})
    }) 
    return promise;
  }
}
